import React from "react";
import View from "./view";
import config from "../../../config";
import MaskedInput from "react-text-mask";
import "./form.css";

export default class ConfirmBookingView extends View {
    static get title() {
        return "подтвердите запись";
    }

    static get titleShort() {
        return "подтверждение";
    }

    static get propTypes() {
        return {
            receiptData: React.PropTypes.object.isRequired
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    constructor(props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            confirmCode: "",

            errorsVisibility: {
                "confirmCode": false,
            },

            errors: {
                "confirmCode": ""
            }
        });

        this._isMounted = false;

        this.codeText = 'На Ваш номер было отправлено SMS с кодом подтверждения. Для продолжения операции укажите код в поле ниже.';

        console.log('booking-props', props);

        //console.log('props.branchInfo.InfoText.codeText', props.branchInfo.InfoText.codeText)

        if(props.branchInfo && props.branchInfo.InfoText) {
            //console.log('props.branchInfo.InfoText.codeText 222222222222', props.branchInfo.InfoText.codeText)
            this.codeText = props.branchInfo.InfoText;
        }


    }

    validateForm() {
        const errorsVisibility = this.state.errorsVisibility;
        const errors = this.state.errors;

        for (const propertyName in this.state.errorsVisibility) {
            if (this.state.errorsVisibility.hasOwnProperty(propertyName)) {
                errorsVisibility[propertyName] = false;
            }
        }

        this.setState({
            errorsVisibility,
            errors
        });

        this.validateConfirmCode().then((confirmData) => {
            if (this._isMounted === true) {

                console.log('confirmData', confirmData);
                if (confirmData.status){
                    this.props.setBookingIsDone(true);
                    this.props.gotoNextView({
                        breadcrumbName: "информация о заказе",
                        nextView: "ReceiptView",
                        props: {
                            receiptData: this.props.receiptData,
                            receiptInfo: confirmData.description,
                        }
                    });
                }else{
                    errorsVisibility["confirmCode"] = true;
                    errors["confirmCode"] = confirmData.description;
                    this.setState({
                        errorsVisibility,
                        errors
                    });
                }

            }
        }).catch((error) => {
            if (this._isMounted === true) {
                errorsVisibility["confirmCode"] = true;
                errors["confirmCode"] = error.message;
                this.setState({
                    errorsVisibility,
                    errors
                });
            }
        });
    }


    handleButtonClick() {
        this.validateForm();
    }


    validateConfirmCode() {
        return new Promise((resolve, reject) => {
            const orderNumber = encodeURIComponent(this.props.receiptData.number);
            const confirmCode = encodeURIComponent(this.state.confirmCode);

            const url = `${config.dataUrl}api.php?function=validation&order=${orderNumber}&code=${confirmCode}`;
            fetch(url).then((response) => {
                return response.json();
            }).then((responseJson) => {
                resolve(responseJson);
            }).catch((error) => {
                reject(error);
            });
        });
    }


    renderErrorMessage(propertyName) {
        if (this.state.errorsVisibility[propertyName]) {
            return <div className="appointment-form__error">{this.state.errors[propertyName]}</div>;
        } else {
            return null;
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleKeyPress(event) {
        if (event.key === "Enter") {
            this.validateForm();
        }
    }


    render() {
        const colors = this.context.muiTheme.palette;

        return (
            <div className="appointment-view appointment-view--confirm-phone">
                <div className="appointment-form">
                    <div className="appointment-form__text">
                        {/* На Ваш номер было отправлено SMS с кодом подтверждения.
                        Для продолжения операции укажите код в поле ниже. */}
                        {this.codeText}
                    </div>


                    <div className="appointment-form__element">
                        <label className="appointment-form__label"> Код подтверждения </label>
                        <MaskedInput
                            style={{
                                backgroundColor: colors.primary3color
                            }}

                            mask={[/\d/, /\d/, /\d/, /\d/]}
                            required="true"
                            value={this.state.confirmCode}
                            onKeyPress={(value) => this.handleKeyPress(value)}
                            onChange={(event) => this.setState({confirmCode: event.target.value})}
                            className="appointment-text-field" type="text"/>

                        {this.renderErrorMessage("confirmCode")}
                    </div>

                    <div className="appointment-form__element">
                        <button
                            style={{
                                backgroundColor: colors.accent5color
                            }}

                            onClick={() => this.handleButtonClick()}
                            type="button"
                            className="appointment-form__button">
                            {"записаться"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/confirm-booking.js
 **/